export default __webpack_public_path__ + "static/media/affiliate-tree.31584e60.svg";